import { useState } from "react"
import { coreRequest, studentRequest } from "services/requests"
import { useGlobalAlert } from "contexts/GlobalAlertContext"
import secureLocalStorage from "react-secure-storage"

const prefix = "notifications"
const sendRequest = coreRequest.sendRequest

const useApi = () => {
  const [isFetching, setIsFetching] = useState(false)
  const { showAlert } = useGlobalAlert()

  const getNotifications = async ({ languageId = null }) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}?notificationTypeId=0&argument1=0&argumnent2=0&languageId=${languageId}`,
      body: null,
      method: "get",
    })
    if (!response.success) showAlert(response.message || "Something went wrong")
    setIsFetching(false)
    return response.data?.notifications
  }

  const getTeacherMessages = async () => {
    setIsFetching(true)
    const response = await studentRequest?.sendRequest({
      endpoint: `teacherMessages`,
      body: null,
      method: "get",
    })
    if (!response.success) showAlert(response.message)
    setIsFetching(false)
    return response.data?.messages
  }

  const getNotificationsNumber = async ({ languageId = null }) => {
    console.log({ languageId })
    if (languageId === null) {
      return {
        notifications: 0,
        messages: 0,
      }
    }
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/getUnreadNotificationsCount?languageId=${languageId}`,
      body: null,
      method: "get",
    })
    if (!response.success) showAlert(response.message)
    setIsFetching(false)
    return (
      response.data || {
        notifications: 0,
        messages: 0,
      }
    )
  }

  const setNotificationSeen = async ({ notificationId }) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/seen/${notificationId}`,
      body: null,
      method: "post",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data
  }

  const setNotificationSeenInformative = async () => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/seen/informative`,
      body: null,
      method: "post",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.data
  }

  const deleteNotification = async ({ notificationId }) => {
    setIsFetching(true)
    const response = await sendRequest({
      endpoint: `${prefix}/delete/${notificationId}`,
      body: null,
      method: "post",
    })
    if (!response.success) showAlert(response.message || "Something went wrong")
    setIsFetching(false)
    return response.data
  }

  const getDeviceSignature = async () => {
    const smashSignature = secureLocalStorage.getItem("smashSignature")
    if (smashSignature !== null) {
      return smashSignature
    } else {
      const str = "0123456789ABCDEF"
      const uuid = []
      for (let i = 0; i < 8; i++) {
        uuid.push(str[Math.floor(Math.random() * str.length)])
      }
      uuid.push("-")
      for (let i = 0; i < 4; i++) {
        uuid.push(str[Math.floor(Math.random() * str.length)])
      }
      uuid.push("-")
      for (let i = 0; i < 4; i++) {
        uuid.push(str[Math.floor(Math.random() * str.length)])
      }
      uuid.push("-")
      for (let i = 0; i < 8; i++) {
        uuid.push(str[Math.floor(Math.random() * str.length)])
      }
      try {
        secureLocalStorage.setItem("smashSignature", uuid.join(""))
      } catch (error) {
        console.log("🚀 ~ getDeviceSignature ~ error:", error)
      }
      return uuid.join("")
    }
  }

  const subscribe = async ({ pushToken }) => {
    setIsFetching(true)
    const deviceSignature = await getDeviceSignature()
    const response = await sendRequest({
      endpoint: `${prefix}/subscribe`,
      body: {
        expoToken: pushToken,
        signature: deviceSignature,
      },
      method: "post",
    })
    if (!response.success) console.log(response.message)
    setIsFetching(false)
    return response.success
  }

  const getTeacherAnnouncement = async ({ referenceId }) => {
    setIsFetching(true)
    const response = await studentRequest?.sendRequest({
      endpoint: `teacherMessages/getAnnounce/${referenceId}`,
      body: null,
      method: "get",
    })
    if (!response.success) showAlert(response.message)
    setIsFetching(false)
    return response.data?.announce
  }

  return {
    getNotificationsNumber,
    getNotifications,
    setNotificationSeen,
    deleteNotification,
    subscribe,
    getTeacherMessages,
    getTeacherAnnouncement,
    getDeviceSignature,
    setNotificationSeenInformative,
    isFetching,
  }
}

export default useApi
